import { render, staticRenderFns } from "./SepetGuncelle.vue?vue&type=template&id=348fd20b&"
import script from "./SepetGuncelle.vue?vue&type=script&lang=js&"
export * from "./SepetGuncelle.vue?vue&type=script&lang=js&"
import style0 from "./SepetGuncelle.vue?vue&type=style&index=0&id=348fd20b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports